<ion-list lines="none">
  <ion-item *ngIf="(role$ | async) >= roleLimits.PARTICIPANT_UPDATE" (click)="rename($event)" button>
    <ion-label class="ion-text-wrap"> Rename </ion-label>
  </ion-item>

  <ion-item (click)="directMessage()" *ngIf="participantId !== this.activeUser$.value.uid" button>
    <ion-label class="ion-text-wrap"> Direct Message </ion-label>
  </ion-item>

  <ion-item *ngIf="studioSession$?.value?.confType !== 'daily'" (click)="showStats()" button>
    <ion-label class="ion-text-wrap"> Show Stats </ion-label>
  </ion-item>

  <ion-item
    *ngIf="
      studioSession$?.value?.confType !== 'daily' &&
      appearance === 'the stage' &&
      (role$ | async) >= roleLimits.PARTICIPANT_UPDATE
    "
    (click)="moveTo('backstage')"
    button>
    <ion-label class="ion-text-wrap"> Move Backstage </ion-label>
  </ion-item>

  <ion-item
    *ngIf="
      studioSession$?.value?.confType !== 'daily' &&
      appearance === 'backstage' &&
      (role$ | async) >= roleLimits.PARTICIPANT_UPDATE
    "
    (click)="moveTo('stage')"
    button>
    <ion-label class="ion-text-wrap">
      {{
       participantId === this.activeUser$.value.uid
          ? 'Move Yourself to The Stage'
          : 'Invite on The Stage'
      }}
    </ion-label>
  </ion-item>

  <ion-item
    *ngIf="
      (role$ | async) >= roleLimits.PARTICIPANT_DELETE && participantId !== this.activeUser$.value.uid
    "
    class="danger"
    (click)="removeFromSession()"
    button>
    <ion-label class="ion-text-wrap"> Remove from Session </ion-label>
  </ion-item>
</ion-list>
